import { render, staticRenderFns } from "./collectionFaceOK.vue?vue&type=template&id=4da1ff45&scoped=true&"
import script from "./collectionFaceOK.vue?vue&type=script&lang=js&"
export * from "./collectionFaceOK.vue?vue&type=script&lang=js&"
import style0 from "./collectionFaceOK.vue?vue&type=style&index=0&id=4da1ff45&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1ff45",
  null
  
)

export default component.exports